type Props = { fill?: string };

const NutritionIcon = ({ fill }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_9384_85012)">
        <path
          d="M13.2009 5.90015C11.8009 4.90015 10.2009 4.80015 8.00091 5.50015C5.90091 4.80015 4.20091 4.90015 2.80091 5.90015C1.10091 7.10015 -0.999094 11.5002 4.80091 16.0002C6.10091 17.1002 8.00091 15.5002 8.00091 15.5002C8.00091 15.5002 9.90091 17.1002 11.2009 16.0002C17.0009 11.5002 14.9009 7.10015 13.2009 5.90015Z"
          fill="#3B3F42"
        />
        <path
          d="M9.7 1.1994C10.7 0.299404 12.3 0.499404 12.3 0.499404C12.3 0.499404 12.2 2.0994 11.1 2.9994C10 3.8994 8.5 3.6994 8.5 3.6994C8.5 3.6994 8.6 2.0994 9.7 1.1994Z"
          fill="#3B3F42"
        />
      </g>
      <defs>
        <clipPath id="clip0_9384_85012">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NutritionIcon;
